<template>
  <div>
    <!-- 确认框 -->
    <confirm
      :isTwoOpe="true"
      message="是否已支付成功？"
      :is-show="isShowConfirm"
      :btn="btnText"
      @no-click="closeConfirm"
      @yes-click="yesClick"
    ></confirm>
  </div>
</template>

<script>
import Confirm from "components/common/confirm/Confirm";
import { isWeiXin } from "common/utils";
export default {
  name: "WeixinPayment",
  components: {
    Confirm,
  },
  data() {
    return {
      isShowConfirm: false,
      btnText: ["支付失败", "支付成功"],
      orderId:'',
    };
  },
  created() {
    // 非微信环境不调用微信支付通知api
    if (!isWeiXin()) {
      this.isShowConfirm = true;
      return false;
    }
     // 一、接收用户支付完成后进入已支付订单列表页传递过来的orderId
    let orderId = this.$route.query.orderId;
    this.orderId = orderId.split('?')[0]
    // appId需要在orderId内取
    let appId = orderId.split('=')[1]
    // return false;
    // url中携带的jsapi参数, 调用微信支付通知api
    const querys = this.$route.query;
    const config = {
      appId: appId,
      timeStamp: querys.timeStamp,
      nonceStr: querys.nonceStr,
      package: querys.prepayId,
      signType: querys.signType,
      paySign: querys.paySign,
    };
    this.$loading.show("");
    const _this = this;
    setTimeout(() => {
      this.$loading.hide();
      if (typeof WeixinJSBridge == "undefined") {
        if (document.addEventListener) {
          document.addEventListener(
            "WeixinJSBridgeReady",
            _this.onBridgeReady(config),
            false
          );
        } else if (document.attachEvent) {
          document.attachEvent(
            "WeixinJSBridgeReady",
            _this.onBridgeReady(config)
          );
          document.attachEvent(
            "onWeixinJSBridgeReady",
            _this.onBridgeReady(config)
          );
        }
      } else {
        _this.onBridgeReady(config);
      }
    }, 2000);
  },
  methods: {
    onBridgeReady(config) {
      const _this = this;
      WeixinJSBridge.invoke(
        "getBrandWCPayRequest",
        {
          appId: config.appId, //公众号名称，由商户传入
          timeStamp: config.timeStamp, //时间戳，自1970年以来的秒数
          nonceStr: config.nonceStr, //随机串
          package: "prepay_id=" + config.package,
          signType: config.signType, //微信签名方式：
          paySign: config.paySign, //微信签名
        },
        function (res) {
          // 使用以上方式判断前端返回,微信团队郑重提示：res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
          if (res && res.err_msg == "get_brand_wcpay_request:ok") {
            _this.$toast.show("支付成功！", 1500);
            setTimeout(() => {
              _this.$router.push("/myOrder");
            }, 1500);
          } else if (res && res.err_msg == "get_brand_wcpay_request:cancel") {
            _this.$toast.show("已取消支付！", 1500);
            setTimeout(function () {
              _this.$router.go(-1);
            }, 1500);
          } else {
            _this.$toast.show("支付失败！", 1500);
            setTimeout(function () {
              _this.$router.push("/myOrder");
            }, 1500);
          }
        }
      );
    },
    // 未支付
    closeConfirm() {
      this.$router.push("/myOrder");
    },
    // 已支付
    yesClick() {
      this.$router.push("/myOrder");
    },
  },
};
</script>

<style>
</style>
